export const ACTIVE_SUBSCRIPTION_STATUSES = [
  'active',
  'trialing',
  'past_due',
  'unpaid',
  'incomplete',
];

export const CANCELED_SUBSCRIPTION_STATUSES = ['incomplete_expired', 'canceled'];
